<template>
   <div class="animated fadeIn">
      <b-row>
         <b-col md="12">
            <b-card>
               <div slot="header">
                  <strong>Hub Management</strong>
                  <div class="card-header-actions" >
                     <b-button size="sm" class="btn btn-sm btn-primary mr-4 btn-pill" data-toggle="tooltip" title="Add New Coordinator" variant='primary' @click="addHub()" :disabled="isReadOnly">Add Hub</b-button>
                     <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" data-toggle="tooltip" title="Refresh"  type="button"><i class="fa fa-refresh"></i></button>
                  </div>
               </div>
               <b-collapse id="my-collapse">
                  <b-card>
                     <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                        <b-row>
                           <b-col sm="6">
                              <b-form-group>
                                 <b-row>
                                    <b-col sm="3">
                                       <label><b>Hub Title</b></label>&nbsp;<span style="color: red;">*</span>
                                    </b-col>
                                    <b-col sm="9">
                                       <b-form-input class="input" type="text" v-model="customer.hubtitle" name="hubtitle"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.hubtitle') }" placeholder="Enter Hub Title">             
                                       </b-form-input>
                                       <b-input-group class="mb-3">
                                          <span class="icon has-text-warning">
                                          <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.hubtitle')" >{{ errors.first('form-1.hubtitle') }}</i>
                                          </span>
                                       </b-input-group>
                                    </b-col>
                                 </b-row>
                              </b-form-group>
                           </b-col>
                           <b-col sm="6">
                              <b-form-group>
                                 <b-row>
                                    <b-col sm="3">
                                       <label><b>Select Admin</b></label>&nbsp;<span style="color: red;">*</span>
                                    </b-col>
                                    <b-col sm="9">
                                       <v-select v-model="customer.selectedAdmin" :options="adminItems" name="admin" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.admin') }" placeholder="-- Select Admin --"></v-select>
                                       <b-input-group class="mb-3">
                                          <span class="icon has-text-warning">
                                          <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.admin')" >{{ errors.first('form-1.admin') }}</i>
                                          </span>
                                       </b-input-group>
                                    </b-col>
                                 </b-row>
                              </b-form-group>
                           </b-col>
                           <b-col sm="6">
                              <b-form-group>
                                 <b-row>
                                    <b-col sm="4">
                                       <label><b>Select Coordinator</b></label>&nbsp;<span style="color: red;">*</span>
                                    </b-col>
                                    <b-col sm="8">
                                       <b-form-checkbox
                                          id="checkbox-1"
                                          v-model="customer.selected_Coordinator"
                                          name="checkbox-1"
                                          value="Coordinator"
                                          unchecked-value=" "
                                          > Coordinator
                                       </b-form-checkbox>
                                    </b-col>
                                 </b-row>
                              </b-form-group>
                              <b-form-group>
                                 <b-row>
                                    <b-col sm="3">
                                       <label><b>Address</b></label>&nbsp;<span style="color: red;">*</span>
                                    </b-col>
                                    <b-col sm="9">
                                       <b-form-textarea  v-model="customer.address" placeholder="Enter Address"
                                          rows="5"
                                          name="address"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.address') }"
                                          ></b-form-textarea>
                                       <b-input-group class="mb-3">
                                          <span class="icon has-text-warning">
                                          <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.address')" >{{ errors.first('form-1.address') }}</i>
                                          </span>
                                       </b-input-group>
                                    </b-col>
                                 </b-row>
                              </b-form-group>
                           </b-col>
                           <b-col sm="6">
                              <b-row>
                                 <b-col sm="12">
                                    <b-form-group>
                                       <b-row>
                                          <b-col sm="3">
                                             <label><b>State</b></label>&nbsp;<span style="color: red;">*</span>
                                          </b-col>
                                          <b-col sm="9">
                                             <b-form-input class="input" type="text" v-model="customer.state" name="state"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.state') }" placeholder="Enter state">             
                                             </b-form-input>
                                             <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.state')" >{{ errors.first('form-1.state') }}</i>
                                                </span>
                                             </b-input-group>
                                          </b-col>
                                       </b-row>
                                    </b-form-group>
                                 </b-col>
                                 <b-col sm="12">
                                    <b-form-group>
                                       <b-row>
                                          <b-col sm="3">
                                             <label><b>City</b></label>&nbsp;<span style="color: red;">*</span>
                                          </b-col>
                                          <b-col sm="9">
                                             <b-form-input class="input" type="text" v-model="customer.city" name="city"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.city') }" placeholder="Enter city">             
                                             </b-form-input>
                                             <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.city')" >{{ errors.first('form-1.city') }}</i>
                                                </span>
                                             </b-input-group>
                                          </b-col>
                                       </b-row>
                                    </b-form-group>
                                 </b-col>
                                 <b-col sm="12">
                                    <b-form-group>
                                       <b-row>
                                          <b-col sm="3">
                                             <label><b>Pincode</b></label>&nbsp;<span style="color: red;">*</span>
                                          </b-col>
                                          <b-col sm="9">
                                             <b-form-input class="input" type="text" v-model="customer.pincode" name="pincode"  v-validate="'required|numeric'" :class="{'input': true, 'is-invalid': errors.has('form-1.pincode') }" placeholder="Enter pincode">             
                                             </b-form-input>
                                             <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.pincode')" >{{ errors.first('form-1.pincode') }}</i>
                                                </span>
                                             </b-input-group>
                                          </b-col>
                                       </b-row>
                                    </b-form-group>
                                 </b-col>
                              </b-row>
                           </b-col>
                           <!-- <b-col sm="6">
                              <b-form-group>   
                                 <b-row>
                                    <b-col md="3"><label><b>Hub Code</b></label>&nbsp;<span style="color: red;">*</span>
                                    </b-col>
                                    <b-col md="9">
                                    <b-form-input class="input" type="text" v-model="customer.hub_code" name="hub code"  v-validate="'required|alpha|min:2'" :class="{'input': true, 'is-invalid': errors.has('form-1.hub code') }" placeholder="Enter Hub Code">             
                                    </b-form-input>
                                  <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                          <i class="fa fa-warning help text-danger" v-show="errors.has('form-1.hub code')" >{{ errors.first('form-1.hub code') }}</i>
                                          
                                        </span>
                                    </b-input-group>
                                  </b-col>
                                  </b-row>
                                </b-form-group>
                              </b-col> -->
                        </b-row>
                        <footer class="column text-right">
                           <b-button variant="primary" size="md"  type="submit">Add</b-button>
                        </footer>
                     </b-form>
                  </b-card>
               </b-collapse>
               <b-row>
                  <b-col md="3" class="my-1">
                     <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                        <b-input-group>
                           <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                           <b-input-group-append>
                              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                           </b-input-group-append>
                        </b-input-group>
                     </b-form-group>
                  </b-col>
                  <b-col sm="9" class="text-right">
                     <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
                  </b-col>
                  <b-col md="12">
                     <b-table show-empty responsive   :items="hubItems" :busy="isBusy" :fields="fields" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" >
                        <div slot="table-busy" class="text-center text-danger my-2">
                           <b-spinner class="align-middle"></b-spinner>
                           <strong>Loading...</strong>
                        </div>
                         <template slot="totalusers" slot-scope="row">
                        <span class="text-primary" style="cursor: pointer;"
                              @click="openUsersModal(row.item.hubid)">
                          {{ row.item.totalusers }}
                        </span>
                      </template>
                        <!-- <template slot="actions" slot-scope="row" >
                           <button class="btn btn-sm " data-toggle="tooltip" title="Upload Pincode" @click="uploadPincodes(row.item)" type="button" style="background: #b0c4de !important;color: #000 !important;">
                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                           </button> 
                           &nbsp;
                           <button class="btn btn-sm " data-toggle="tooltip" title="Click to download"  type="button" style="background: #b0c4de !important;color: #000 !important;">
                           <a  :href="csvdownlaod+row.item.hubid" target="_blank">
                           <i class="fa fa-download" style="color:#333" aria-hidden="true" ></i></a>
                           </button> 
                           
                           </template> -->
                        <template slot="action" slot-scope="row" >
                           <button class="btn btn-sm btn-primary mr-4" title="View QR Code." @click="openHubQR(row.item.hubid, row.item.hubname)">
                           View QR
                           </button>
                        </template>
                     </b-table>
                  </b-col>
                  <b-modal size="md" title="Assign Pincodes" v-model="pincodesModal" @ok="pincodesModal = false" hide-footer>
                     <template slot="default" slot-scope="{ hide }">
                        <!-- Code For Upload Pincode CSV -->
                        <b-form @submit.prevent="validateFormCsv('form-3')" data-vv-scope="form-1">
                           <b-form-group label="Upload Pincodes CSV"  :label-cols="4" >
                              <b-form-file
                                 name="file"
                                 type="file"
                                 v-model="file"
                                 :state="Boolean(file)"
                                 @change="selectcsvFiletoUpload($event)"
                                 placeholder="Upload CSV File" accept=".csv" required v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-3.file') }"
                                 ></b-form-file>
                              <span v-show="errors.has('form-3.file')" class="help text-danger">{{ errors.first('form-3.file') }}</span>
                              <label for="name"><a  href="img/hubpincode.csv" download="hubpincode.csv" target="_blank">Download Sample CSV</a>
                              </label>
                           </b-form-group>
                           <div slot="footer" class="text-right">
                              <b-button type="submit" size="sm" class="mr-4" variant="primary"> Upload</b-button>
                              <b-button  size="sm" variant="danger" @click="pincodecancel()">cancel</b-button>
                           </div>
                           <div id="overlayModal" >
                              <div class="loaderModal"></div>
                           </div>
                        </b-form>
                        <br>
                        <div style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);" class="mb-1">
                           <b-col md="12">
                              <b>Assign Pincodes to Hub </b>
                              <br>
                              <br>
                              <span>
                                 <h6>
                                    <b>Source Pincodes : </b>
                                    <span  v-for="source in sourcepincodes">{{source}}&nbsp;&nbsp; </span>
                                 </h6>
                                 <br>
                                 <h6>
                                    <b>Destination Pincodes : </b>
                                    <span  v-for="destination in destinationpincode">{{destination}}&nbsp;&nbsp; </span>
                                 </h6>
                              </span>
                           </b-col>
                        </div>
                     </template>
                     <template slot="modal-footer" slot-scope="{ hide }">
                        <!-- Emulate built in modal footer ok and cancel button actions -->
                        <b-button size="sm" style="display:none">
                           Cancel
                        </b-button>
                        <!-- Button with custom close trigger value -->
                     </template>
                  </b-modal>
                  <b-modal
                     size="md"
                     v-model="viewQrModal"
                     hide-footer
                     >
                     <!-- Custom Header with Title, Print, and Close Buttons -->
                     <template #modal-header>
                        <div class="d-flex w-100 align-items-center justify-content-between">
                           <h5 class="modal-title mb-0">Hub QR For Vehicle Attendance</h5>
                           <div class="d-flex align-items-center">
                              <b-button
                                 variant="primary"
                                 size="sm"
                                 class="mr-2"
                                 @click.stop="printHubQRCode"
                                 >
                                 Print
                              </b-button>
                              <b-button-close @click="viewQrModal = false" />
                           </div>
                        </div>
                     </template>
                     <!-- Printable QR Code Content -->
                     <div
                        id="printableQRHub"
                        style="display: flex; flex-direction: column; justify-content: center; align-items: center;"
                        >
                        <strong> HUB ID : {{ vehicleAttendanceHub_id }}</strong>
                        <qr-code :text="vehicleAttendanceHub_id+ '$' + vehicleAttendanceHub_name"></qr-code>
                        <br />               
                     </div>
                  </b-modal>
                  <b-modal size="xl" v-model="hubUsersModal" title="Hub Users" hide-footer>
                  <div class="mb-2">
                  <strong>Total Users: {{ hubUsers.length }}</strong>
               </div>
                    <b-table striped hover :items="hubUsers" :fields="userFields" >
                      <template  slot="isactive" slot-scope="row">
                        <span v-if="row.item.isactive === 'Yes'" class="badge badge-success">Active</span>
                        <span v-else class="badge badge-danger">Inactive</span>
                      </template>
                    </b-table>
                  </b-modal>
               </b-row>
            </b-card>
         </b-col>
      </b-row>
   </div>
</template>
<script>
   import CONSTANTS from '@/utils/constants'
   import Utils from '@/utils'
   import Vue from 'vue'
   export default {
     data: function() {
       return {
         totalRows:0,
         isBusy:false,
         // currentPage:1,
         // perPage:10,
         bordered:true,
         pageOptions: [5, 10, 15],
         sortBy: null,
         sortDesc: false,
         sortDirection: 'asc',
         filter: null,
         fields:[
               { key: 'hubid', label: 'HUB ID', sortable: true},             
               { key: 'hubname', label: 'HUB Name', sortable: true},
                { key: 'hub_state', label: 'HUB State', sortable: true},
               { key: 'totalusers', label: 'Total Users', sortable: true},
               { key: 'admin_id', label: 'Admin Id', sortable: true},
               { key: 'sysemailid', label: 'Admin Mail Id', sortable: true},
               { key: 'adminname', label: 'Admin Name', sortable: true},
               { key: 'hub_address', label: 'Address', sortable: true},
               { key: 'action', label: 'Action'},
   
               
         ],
         hubItems:[],
         select:'',
         // selectedAdmin:'',
         customer:{
           hubtitle :'',
           selectedAdmin :'',
           address :'',
           state :'',
           city :'',
           pincode :'',
         },
         adminItems:[],
         admin_items :[],
         pincodesModal:false,
         selectcsvFile:'',
         selectFiletype:'',
         hub_id:'',
         sourcepincodes:[],
         destinationpincode:[],
         pincodeMsg:'',
         csvdownlaod:'',
         // selected_Coordinator :'',
         accessBody:[],
         isReadOnly:false,
         viewQrModal:false,
        hubUsersModal: false,
        hubUsers: [],
        userFields: [
          { key: 'sysusermasterid', label: 'User ID' },
          { key: 'sysemailid', label: 'Email' },
          { key: 'userfirstname', label: 'First Name' },
          { key: 'userlastname', label: 'Last Name' },
          { key: 'usermobilenumber', label: 'Mobile Number' },
           { key: 'user_type', label: 'User Type' },
          { key: 'admin_as_coordinator', label: 'Coordinator' },
          { key: 'isactive', label: 'Active' }
        ],
       }
     },
     created: function() { 
       var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          this.accessBody = userInfo.body;
         this.ischeckbodyvalidation();
       this.hubListing();
     },
    methods: {
    async openUsersModal(hubId) {
        this.hubUsers = []
        this.hubUsersModal = true
        try {
          const response = await this.$http.post(
            `${CONSTANTS.MIGRATION_API_URL}/getUsersByHubId`,
            { hubid: hubId }
          )
          if (response.body.returnmsg === "Successful") {
            this.hubUsers = response.body.returnvalue
          } else {
            this.hubUsers = []
            this.$fire({
              text: response.body.returnvalue || "No users found",
              type: "error",
              timer: 5000
            })
          }
        } catch (err) {
          console.error(err)
          this.$fire({
            text: "Error fetching hub users",
            type: "error",
            timer: 5000
          })
        }
      },
     ischeckbodyvalidation(){
             for (let i = 0; i < this.accessBody.length; i++) {
                 const element = this.accessBody[i];
             
                 // if (element.title=='Hub Management' && element.isReadonly==true && this.route_id=='normal') {
                 //   this.isReadOnly=true
                 // }
             if (element.child) {
                 for (let j = 0; j < element.child.length; j++) {
                 const k = element.child[j];
                 if (k.title=='Hub Management' && k.isReadonly==true) {
                     this.isReadOnly=true
                 }
                 }
             }
             }
             console.log(" this.isReadOnly", this.isReadOnly)
         },
       validateForm(scope) {
         this.$validator.validateAll(scope).then(result => {
           if(result){
             this.addHubForm()
           }
         })
       },
       
       addHubForm(){
         document.getElementById("overlay").style.display = "block";
         var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
         console.log('this.customer.selectedAdmin',this.customer.selectedAdmin)
         
         let selectadminuserid='';

         if (this.customer.selectedAdmin != null && this.customer.selectedAdmin !== undefined) {
           var selectedAdmin = this.customer.selectedAdmin.split("-");
            console.log("iiiiiiiii11",selectedAdmin[1])
           this.customer.selectedAdmin=selectedAdmin[1];
           selectadminuserid=selectedAdmin[1];
         } else {
            selectadminuserid= this.customer.selectedAdmin;
               if (selectadminuserid !== undefined && selectadminuserid !== null) {
              
               }else{
                this.$fire({
                        text:"please Select Admin",
                        type: "Warning",
                        timer: 30000
                     }); 
                     }
               }
         

         console.log('selectadminuseridselectadminuserid',selectadminuserid)

         var sysusermasterid = userInfo.sysusermasterid;

         
         const hubObj = {
         hubtittle:`${this.customer.hubtitle}`,
         adminsysusermasterid:selectadminuserid,
         hub_address:`${this.customer.address}`,
         hub_state:`${this.customer.state}`,
         hub_city:`${this.customer.city}`,
         hub_pincode:`${this.customer.pincode}`,
         admin_as_coordinator : this.customer.selected_Coordinator == "Coordinator" ? 'Yes' : 'No',
         // hub_code:`${this.customer.hub_code}`,
       };
       console.log("hubObj",hubObj);
       // return false;
         this.$http
               .post(
                 `${ CONSTANTS.MIGRATION_API_URL}/createHubAndAssignToAdminapi`,hubObj).then(result => {
                 document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                   // Utils.notify("Added Successfully", "success");
                   this.$fire({
                   text:"Added Successfully",
                   type: "success",
                   timer: 30000
                 }); 
                   
                   this.customer = {};
                   this.errors.clear('form-1');
                    var adduser = document.getElementById("my-collapse");
                   adduser.style.display = "none"; 
                  
                   this.hubListing();
                 } else {
                     this.$fire({
                     text:result.body.returnvalue,
                     type: "error",
                     timer: 30000
                   }); 
                 }
                 
               })
               .catch(ex => {
                 console.log("error", ex);
               });
        },
        hubListing(){
         this.isBusy=true;
         var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
         const obj={
           sysusermasterid:`${userInfo.sysusermasterid}`,
           usertype : `${userInfo.user_type}`,
         }
         console.log("objlist",obj)
         this.$http
               .post(
                 `${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj).then(result => {
                   this.isBusy=false;
                   if (result.body.returnmsg === "Successful") {
                    this.hubItems=result.body.returnvalue;
                    
                    this.totalRows=result.body.returnvalue.length;
                    const url = `http://65.2.154.47/api_ftl/getCsvforHubidPincodes?hubid=`
                    this.csvdownlaod=url;
                    
                   }else{
                     this.hubItems=[];
                     this.totalRows=0;
                   }
                 }).catch(ex => {
                 console.log("error", ex);
               });
        },
     
     addHub(){
       this.errors.clear("form-1");
       var adduser = document.getElementById("my-collapse");
       adduser.style.display = "block";
       this.adminList();
      },
      refresh:function() {
       var adduser = document.getElementById("my-collapse");
       adduser.style.display = "none";
       this.customer = {};
       this.errors.clear('form-1');
     },
     adminList(){
     	  var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
         const obj={}
         this.$http
               .post(
                 `${ CONSTANTS.MIGRATION_API_URL}/getAdminListingAvailableForHub`,obj).then(result => {
                   if (result.body.returnmsg === "Successful") {
                    this.admin_items=result.body.returnvalue;
                    
                    for (let i = 0; i < this.admin_items.length; i++) {
                     var admin_ids = this.admin_items[i].adminname + "-" + this.admin_items[i].adminsysusermasterid;
                     this.adminItems.push(admin_ids)
                    }
                    console.log("admin",this.adminItems)
                    // this.totalRows=result.body.returnvalue.length;
                    
                   }else{
                     this.admin_items=[];
                     // this.totalRows=0;
                   }
                 }).catch(ex => {
                 console.log("error", ex);
               });
     },
     uploadPincodes(item){
       this.hub_id=item.hubid;
       // console.log("Tsets",item);this.sourcepincodes='';
       this.sourcepincodes=[];
       this.destinationpincode=[];
       this.pincodeMsg='';
       this.pincodesModal=true;
       this.getAllPincodesAgainstHubid();
   
     },
     pincodecancel(){
       this.pincodesModal=false;
       this.selectcsvFile='';
       this.selectFiletype='';
       this.file='';
     },
     validateFormCsv(scope){
         this.$validator.validateAll(scope).then(result => {
         if (result) {          
           this.uploadPincodeCsv();
         }
       });
       },
       uploadPincodeCsv(){
         document.getElementById("overlayModal").style.display = "block";
         var userdata = localStorage.getItem("userData");
         var userInfo = JSON.parse(userdata);
         console.log("UserInfo",userInfo);
         if(this.selectFiletype == 'text/csv'){
           let data = new FormData();
           
           data.append('hubid',`${this.hub_id}`)
           data.append('createdby',`${userInfo.userfirstname}` + '' + `${userInfo.userlastname}`)
           data.append('updatedby',`${userInfo.sysusermasterid}`)
           data.append('file', this.selectcsvFile)
           let config = {
             header : {
               'Content-Type' : 'multipart/form-data'
               }
           }
           console.log("Config",config);
       // return false;
            this.$http
         .post(
           `${
             CONSTANTS.MIGRATION_API_URL
           }/uploadPincodeCSVtoHub`,
           data,{ header : {
                      'Content-Type' : 'multipart/form-data'
                    }
          }).then(result => {
           document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg === 'Successful') {      
               this.$fire({
                   text:result.body.returnvalue,
                   type: "success",
                   timer: 30000
                 });
               this.selectcsvFile='';
               this.selectFiletype='';
               this.file='';
               this.pincodesModal=false;
               this.hubListing();
           }else{
               this.$fire({
                   text:result.body.returnvalue,
                   type: "error",
                   timer: 30000
                 }); 
             }
   
       }).catch(ex => {
           console.log("error", ex);
         });
       }else{
       document.getElementById("overlayModal").style.display = "none";
         this.$fire({
                   text:"Please Upload CSV File Only",
                   type: "error",
                   timer: 30000
                 }); 
       }
       },
       selectcsvFiletoUpload(event){
          this.selectcsvFile= event.target.files[0];
          console.log("Test",this.selectcsvFile);
       
          this.selectFiletype= event.target.files[0].type;
        
   
     },
     getAllPincodesAgainstHubid(){
   
         const obj={
           hubid:this.hub_id
         }
         this.$http
               .post(
                 `${ CONSTANTS.MIGRATION_API_URL}/getAllPincodesAgainstHubid`,obj).then(result => {
                   this.pincodeMsg=result.body.returnmsg;
                   if (result.body.returnmsg === "Successful") {
                     this.sourcepincodes=result.body.sourcepincodes.split(',');
                    
                    this.destinationpincode=result.body.destinationpincode.split(',');
                    
                    
                   }else{
                     this.sourcepincodes=[];
                     this.destinationpincode=[];
                   }
                 }).catch(ex => {
                 console.log("error", ex);
               });
     },
      
      openHubQR(hubid, hubname){        
         this.vehicleAttendanceHub_id=hubid;
         this.vehicleAttendanceHub_name=hubname;
         this.viewQrModal=true
         console.log("HUB ID FOR QR---->>>", this.vehicleAttendanceHub_id);
       },
      
       printHubQRCode() {
         this.$nextTick(() => {
           const printContents = document.getElementById("printableQRHub").innerHTML;
           const disp_setting = "toolbar=yes,location=no,directories=yes,menubar=yes," +
             "scrollbars=yes,width=650,height=600,left=100,top=25";
           const docprint = window.open("", "", disp_setting);
   
           docprint.document.open();
           docprint.document.write('<!DOCTYPE html><html><head>');
           docprint.document.write('<meta charset="utf-8"/>');
           docprint.document.write('<title>Print QR</title>');
           docprint.document.write('<style>');
           docprint.document.write("body{ margin:0; font-family:Verdana, Geneva, sans-serif; font-size:16px; text-align: center; }");
           docprint.document.write("@page { size: auto; margin: 10mm; }");
           docprint.document.write("</style>");
           docprint.document.write('</head><body onload="window.print(); window.close();">');
           docprint.document.write(printContents);
           docprint.document.write('</body></html>');
           docprint.document.close();
         });
       }
       
     
    },
    
   };
</script>
<style>
   #overlayModal {
   position: fixed; /* Sit on top of the page content */
   display: none; /* Hidden by default */
   width: 100%; /* Full width (cover the whole page) */
   height: 100%; /* Full height (cover the whole page) */
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background-color: rgba(0,0,0,0.5); /* Black background with opacity */
   z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
   cursor: pointer; /* Add a pointer on hover */
   }
   .loaderModal {
   position: relative;
   border: 5px solid #f3f3f3;
   border-radius: 50%;
   border-top: 5px solid #3498db;
   width: 30px;
   height: 30px;
   left:50%;
   top:50%;
   -webkit-animation: spin 2s linear infinite; /* Safari */
   animation: spin 2s linear infinite;
   }
   /* Safari */
   @-webkit-keyframes spin {
   0% { -webkit-transform: rotate(0deg); }
   100% { -webkit-transform: rotate(360deg); }
   }
   @keyframes spin {
   0% { transform: rotate(0deg); }
   100% { transform: rotate(360deg); }
   }
</style>
